import { Fragment, useContext, useEffect } from 'react';
import { Bar, Doughnut } from "react-chartjs-2";
import { AuthContext } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { currencyFormatter, numberFormatter, sort } from '../../utils/common';
import { CruiseContext } from '../../contexts/CruiseContext';

const ChartBar = props => {
    const { t } = useTranslation();
    const { authState: { users }, getUsers } = useContext(AuthContext)
    useEffect(() => getUsers(''), []) // eslint-disable-line react-hooks/exhaustive-deps

    const {
        cruiseState: { cruises },
        getCruises
    } = useContext(CruiseContext)

    if (!cruises || !cruises.length) {
        getCruises();
    }

    const bookings = props.bookingProps;
    const cruiseName = props.cruiseNameProps;
    const companyData = props.companyData;
    const oosDaysNumber = props.oosDaysNumber;

    // cruise
    let totalPeople = 0;
    let totalRevenueVND = 0;
    let totalRevenueUSD = 0;
    let totalPendingPeople = 0;
    let totalPendingRevenueVND = 0;
    let totalPendingRevenueUSD = 0;
    let maxCustomer = props.maxCustomer;
    let daysInMonths = new Date(props.year, props.month, 0).getDate() - oosDaysNumber;
    maxCustomer = maxCustomer * daysInMonths;
    const dataPeople = bookings.map((booking) => {
        const cusTotal = booking.adults + booking.children + booking.children11 + booking.infants;
        booking.CusTotal = cusTotal;
        booking.PendingTotal = (booking.pending_adults || 0) + (booking.pending_children || 0) + (booking.pending_children11 || 0) + (booking.pending_infants || 0);
        // maxCustomer = booking.cruise_max_customer;
        return booking;
    });

    let pieChartData = []
    
    if(users !== null){
        users.map((item) => {
            //var total = 0
            if(item.department === 'sale' || item.department === 'isale'){
                let dataItem = {
                    name: item.name,
                    CusTotal: 0,
                    vndValue: 0,
                    usdValue: 0,
                    PendingTotal: 0,
                    pendingVndValue: 0,
                    pendingUsdValue: 0
                }
                
                const p = dataPeople.find((i) => {
                    return i.user_id == item.id;
                })
                
                if (p) {
                    dataItem = {...dataItem, ...p};
                    dataItem.vndValue = p.revenue_vnd;
                    dataItem.usdValue = p.revenue_usd;
                    dataItem.PendingTotal = p.PendingTotal;
                    dataItem.pendingVndValue = p.pending_revenue_vnd;
                    dataItem.pendingUsdValue = p.pending_revenue_usd;
                }
                    
                totalPeople += dataItem.CusTotal? dataItem.CusTotal: 0;
                totalRevenueVND += dataItem.vndValue? dataItem.vndValue: 0;
                totalRevenueUSD += dataItem.usdValue? dataItem.usdValue: 0;
                
                totalPendingPeople += dataItem.PendingTotal? dataItem.PendingTotal: 0;
                totalPendingRevenueVND += dataItem.pendingVndValue? dataItem.pendingVndValue: 0;
                totalPendingRevenueUSD += dataItem.pendingUsdValue? dataItem.pendingUsdValue: 0;

                pieChartData.push(dataItem);
            }
        })
    }
    
    sort(pieChartData, 'CusTotal');
    const revenueLabels = pieChartData.map((item) => item.name);
    const stillPeople = maxCustomer - totalPeople - totalPendingPeople;
    const stillPeopleNoPending = maxCustomer - totalPeople;
    const dataAdults = pieChartData.map((booking) => {
        return booking.adults;
    });
    const dataChildren = pieChartData.map((booking) => {
        return booking.children;
    });
    const dataChildren11 = pieChartData.map((booking) => {
        return booking.children11;
    });
    const dataInfant = pieChartData.map((booking) => {
        return booking.infants;
    });
    const dataPending = pieChartData.map((booking) => {
        return booking.PendingTotal;
    });

    const pieChartLabelsNoPending = pieChartData.map((item) => {
        return `${item.name}: ${maxCustomer? numberFormatter(2).format(item.CusTotal * 100 / maxCustomer): 0}%`;
    });
    pieChartLabelsNoPending.push(`${t('Still Empty')}: ${maxCustomer? numberFormatter(2).format(stillPeopleNoPending * 100 / maxCustomer): 0}%`);
    const pieChartValuesNoPending = [...pieChartData.map((item) => item.CusTotal), stillPeopleNoPending > 0 ? stillPeopleNoPending : 0];

    const pieChartLabels = pieChartData.map((item) => {
        const itemTotal = item.CusTotal + (item.PendingTotal || 0);
        let label = `${item.name}: ${maxCustomer? numberFormatter(2).format(itemTotal * 100 / maxCustomer): 0}%`;
        if (item.PendingTotal > 0) {
            label += ` (${item.CusTotal} + ${item.PendingTotal} ${t('Pending')})`;
        }
        return label;
    });
    pieChartLabels.push(`${t('Still Empty')}: ${maxCustomer? numberFormatter(2).format((stillPeople > 0 ? stillPeople : 0) * 100 / maxCustomer): 0}%`);
    
    // The Values
    const pieChartValues = [...pieChartData.map((item) => item.CusTotal + (item.PendingTotal || 0)), stillPeople > 0 ? stillPeople : 0];

    const pieChartVNDValues = pieChartData.map((item) => item.vndValue);
    const pieChartUSDValues = pieChartData.map((item) => item.usdValue);
    const pieChartPendingVNDValues = pieChartData.map((item) => item.pendingVndValue);
    const pieChartPendingUSDValues = pieChartData.map((item) => item.pendingUsdValue);
    // end cruise

    // company
    let companyCustomer = 0;
    let companyRevenueVND = 0;
    let companyRevenueUSD = 0;
    let companyPendingCustomer = 0;
    let companyPendingRevenueVND = 0;
    let companyPendingRevenueUSD = 0;
    const cData = companyData.map((item) => {
        const cusTotal = item.adults + item.children + item.children11 + item.infants;
        const pendingTotal = (item.pending_adults || 0) + (item.pending_children || 0) + (item.pending_children11 || 0) + (item.pending_infants || 0);
        item.CusTotal = cusTotal;
        item.PendingTotal = pendingTotal;
        companyCustomer += cusTotal? cusTotal: 0;
        companyRevenueVND += item.revenue_vnd? item.revenue_vnd: 0;
        companyRevenueUSD += item.revenue_usd? item.revenue_usd: 0;

        companyPendingCustomer += pendingTotal? pendingTotal: 0;
        companyPendingRevenueVND += item.pending_revenue_vnd? item.pending_revenue_vnd: 0;
        companyPendingRevenueUSD += item.pending_revenue_usd? item.pending_revenue_usd: 0;

        return item;
    });

    const companyMaxCustomer = cruises.reduce((total, {max_customer}) => {
        return total + max_customer;
    }, 0);

    const companyMaxCustomerInMonth = companyMaxCustomer * daysInMonths;

    sort(cData, 'CusTotal');
    const companyAdults = cData.map((item) => {
        return item.adults;
    });
    const companyChildren = cData.map((item) => {
        return item.children;
    });
    const companyChildren11 = cData.map((item) => {
        return item.children11;
    });
    const companyInfant = cData.map((item) => {
        return item.infants;
    });
    const companyPending = cData.map((item) => {
        return item.PendingTotal;
    });
    const companyLabels = cData.map((item) => item.cruise_name);
    const companyRevenueVNDLabels = cData.map((item) => {
        let text = `${item.cruise_name}: ${companyRevenueVND? numberFormatter(2).format(item.revenue_vnd * 100 / companyRevenueVND): 0}%`;
        if (item.pending_revenue_vnd > 0) {
            text += ` (+${currencyFormatter().format(item.pending_revenue_vnd)} ${t('Pending')})`;
        }
        return text;
    });
    const companyRevenueUSDLabels = cData.map((item) => {
        let text = `${item.cruise_name}: ${companyRevenueUSD? numberFormatter(2).format(item.revenue_usd * 100 / companyRevenueUSD): 0}%`;
        if (item.pending_revenue_usd > 0) {
            text += ` (+${currencyFormatter('USD').format(item.pending_revenue_usd)} ${t('Pending')})`;
        }
        return text;
    });
    const stillCompanyNoPending = companyMaxCustomerInMonth - companyCustomer;
    const companyPieChartLabelsNoPending = cData.map((item) => {
        return `${item.cruise_name}: ${companyMaxCustomerInMonth? numberFormatter(2).format(item.CusTotal * 100 / companyMaxCustomerInMonth): 0}%`;
    });
    companyPieChartLabelsNoPending.push(`${t('Still Empty')}: ${companyMaxCustomerInMonth? numberFormatter(2).format(stillCompanyNoPending * 100 / companyMaxCustomerInMonth): 0}%`);
    const companyPieChartValuesNoPending = [...cData.map((item) => item.CusTotal), stillCompanyNoPending > 0 ? stillCompanyNoPending : 0];

    const companyPieChartLabels = cData.map((item) => {
        const itemTotal = item.CusTotal + (item.PendingTotal || 0);
        let label = `${item.cruise_name}: ${companyMaxCustomerInMonth? numberFormatter(2).format(itemTotal * 100 / companyMaxCustomerInMonth): 0}%`;
        if (item.PendingTotal > 0) {
            label += ` (${item.CusTotal} + ${item.PendingTotal} ${t('Pending')})`;
        }
        return label;
    });
    const stillCompanyWithPending = companyMaxCustomerInMonth - companyCustomer - companyPendingCustomer;
    companyPieChartLabels.push(`${t('Still Empty')}: ${companyMaxCustomerInMonth? numberFormatter(2).format((stillCompanyWithPending > 0 ? stillCompanyWithPending : 0) * 100 / companyMaxCustomerInMonth): 0}%`);
    
    // The values
    const companyPieChartValues = [...cData.map((item) => item.CusTotal + (item.PendingTotal || 0)), stillCompanyWithPending > 0 ? stillCompanyWithPending : 0];
    const cPieChartRevenuesVND = cData.map((item) => item.revenue_vnd);
    const cPieChartRevenuesUSD = cData.map((item) => item.revenue_usd);
    const cPieChartPendingRevenuesVND = cData.map((item) => item.pending_revenue_vnd);
    const cPieChartPendingRevenuesUSD = cData.map((item) => item.pending_revenue_usd);
    
    // end company

    const baseColors = ['#36A2F5', '#34BFA3', '#FF518A', '#E07A10', '#631D7F', '#A426B399', '#F3236699', '#081AF1', '#129A3C', '#102F75', '#e2ec52', '#333333'];
    const getPieColors = (labels) => {
        return labels.map((label, index) => {
            if (label.includes(t('Still Empty'))) return '#67655F99';
            if (label.includes(t('Pending (All)'))) return 'rgba(180,180,180,.6)';
            return baseColors[index % baseColors.length];
        });
    };

    const pieColorsNoPending = getPieColors(pieChartLabelsNoPending);
    const pieColors = getPieColors(pieChartLabels);
    const companyPieColorsNoPending = getPieColors(companyPieChartLabelsNoPending);
    const companyPieColors = getPieColors(companyPieChartLabels);
    
    return (
        <Fragment>
            <div className="horizontal-mainwrapper clearfix">
                <div className="charjs">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>{cruiseName}</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="style-bar">
                                <div className="style-bar-chart">
                                    <Bar
                                        data={{
                                        labels: revenueLabels,
                                        datasets: [
                                            {
                                                label: t('Adults'),
                                                backgroundColor: "rgba(240,197,65,.6)",
                                                borderColor: "rgba(240,197,65,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: dataAdults
                                            },
                                            {
                                                label: t('Children'),
                                                backgroundColor: "rgba(46,205,153,.6)",
                                                borderColor: "rgba(46,205,153,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: dataChildren
                                            },
                                            {
                                                label: t('Children11'),
                                                backgroundColor: "rgba(9,166,9,.6)",
                                                borderColor: "rgba(9,166,9,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: dataChildren11
                                            },
                                            {
                                                label: t('Infants'),
                                                backgroundColor: "rgba(78,157,230,.6)",
                                                borderColor: "rgba(78,157,230,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: dataInfant
                                            },
                                            {
                                                label: t('Pending Pax'),
                                                backgroundColor: "rgba(180,180,180,.6)",
                                                borderColor: "rgba(180,180,180,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                data: dataPending
                                            }
                                            ]
                                        }}
                                        options={{
                                            responsive: true,
                                            legend: { display: false },
                                            title: {
                                                display: true,
                                                text: t("Sale Report")
                                            },
                                            // scales: {
                                            //     xAxes: [{
                                            //         stacked: true
                                            //     }],
                                            //     yAxes: [{
                                            //         stacked: true
                                            //     }]
                                            // }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h2>{t('Total Pax (Confirmed)')} : {totalPeople} / {maxCustomer} ({maxCustomer? numberFormatter(2).format(totalPeople * 100/maxCustomer): 0}%)</h2>
                            <div className="pie-charts mt-2">
                                <div className="pie-charts-doughnut">
                                    <Doughnut
                                        data={{
                                        labels: pieChartLabelsNoPending,
                                        datasets: [
                                            {
                                                label: t("Population (millions)"),
                                                backgroundColor: pieColorsNoPending,
                                                data: pieChartValuesNoPending
                                            }
                                        ]
                                        }}
                                        option={{
                                            title: {
                                                display: true,
                                                text: t("Total Pax")
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <h2 className="mt-5">{t('Total Pax (Include Pending)')} : {totalPeople + totalPendingPeople} / {maxCustomer} ({maxCustomer? numberFormatter(2).format((totalPeople + totalPendingPeople) * 100/maxCustomer): 0}%)</h2>
                            <div className="pie-charts mt-2">
                                <div className="pie-charts-doughnut">
                                    <Doughnut
                                        data={{
                                        labels: pieChartLabels,
                                        datasets: [
                                            {
                                                label: t("Population (millions)"),
                                                backgroundColor: pieColors,
                                                data: pieChartValues
                                            }
                                        ]
                                        }}
                                        option={{
                                            title: {
                                                display: true,
                                                text: t("Total Pax")
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='margin-bottom-50'></hr>
                    <div className='row margin-bottom-50'>
                        <div className='col-md-12'>
                            <h2 className='text-center'>{t('Revenue Chart')}</h2>
                            <p className='text-center'> 
                                <strong>{t('Revenue Total (VND)')}:</strong> {currencyFormatter().format(totalRevenueVND)} (+ {currencyFormatter().format(totalPendingRevenueVND)} {t('Pending')} )
                                <span className="mx-2">|</span>
                                <strong>{t('Revenue Total (USD)')}:</strong> {currencyFormatter('USD').format(totalRevenueUSD)} (+ {currencyFormatter('USD').format(totalPendingRevenueUSD)} {t('Pending')} )
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="style-bar">
                                <div className="style-bar-chart">
                                <Bar
                                    data={{
                                    labels: revenueLabels,
                                    datasets: [
                                        {
                                            label: t('Revenue (VND)'),
                                            backgroundColor: "rgba(240,197,65,.6)",
                                            borderColor: "rgba(240,197,65,.6)",
                                            borderWidth: 1,
                                            stack: 1,
                                            data: pieChartVNDValues
                                        },
                                        {
                                            label: t('Pending Revenue (VND)'),
                                            backgroundColor: "rgba(180,180,180,.6)",
                                            borderColor: "rgba(180,180,180,.6)",
                                            borderWidth: 1,
                                            stack: 1,
                                            data: pieChartPendingVNDValues
                                        },
                                        ]
                                    }}
                                    options={{
                                        responsive: true,
                                        legend: { display: false },
                                        title: {
                                            display: true,
                                            text: t("Sale Report")
                                        },
                                        // scales: {
                                        //     xAxes: [{
                                        //         stacked: true
                                        //     }],
                                        //     yAxes: [{
                                        //         stacked: true
                                        //     }]
                                        // }
                                    }}
                                />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="style-bar">
                                <div className="style-bar-chart">
                                <Bar
                                    data={{
                                    labels: revenueLabels,
                                    datasets: [
                                        {
                                            label: t('Revenue (USD)'),
                                            backgroundColor: "rgba(240,197,65,.6)",
                                            borderColor: "rgba(240,197,65,.6)",
                                            borderWidth: 1,
                                            stack: 1,
                                            data: pieChartUSDValues
                                        },
                                        {
                                            label: t('Pending Revenue (USD)'),
                                            backgroundColor: "rgba(180,180,180,.6)",
                                            borderColor: "rgba(180,180,180,.6)",
                                            borderWidth: 1,
                                            stack: 1,
                                            data: pieChartPendingUSDValues
                                        },
                                        ]
                                    }}
                                    options={{
                                        responsive: true,
                                        legend: { display: false },
                                        title: {
                                            display: true,
                                            text: t("Sale Report")
                                        },
                                        // scales: {
                                        //     xAxes: [{
                                        //         stacked: true
                                        //     }],
                                        //     yAxes: [{
                                        //         stacked: true
                                        //     }]
                                        // }
                                    }}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='margin-bottom-50'></hr>
                    <div className='row margin-bottom-50'>
                        <div className='col-md-12'>
                            <h2 className='text-center'>{t('Company Summary Chart')}</h2>
                            <p className='text-center'> 
                                <strong>{t('Revenue Total (VND)')}:</strong> {currencyFormatter().format(companyRevenueVND)} (+ {currencyFormatter().format(companyPendingRevenueVND)} {t('Pending')} )
                                <span className="mx-2">|</span>
                                <strong>{t('Revenue Total (USD)')}:</strong> {currencyFormatter('USD').format(companyRevenueUSD)} (+ {currencyFormatter('USD').format(companyPendingRevenueUSD)} {t('Pending')} )
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="style-bar">
                                <div className="style-bar-chart">
                                    <Bar
                                        data={{
                                        labels: companyLabels,
                                        datasets: [
                                            {
                                                label: t('Adults'),
                                                backgroundColor: "rgba(240,197,65,.6)",
                                                borderColor: "rgba(240,197,65,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: companyAdults
                                            },
                                            {
                                                label: t('Children'),
                                                backgroundColor: "rgba(46,205,153,.6)",
                                                borderColor: "rgba(46,205,153,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: companyChildren
                                            },
                                            {
                                                label: t('Children11'),
                                                backgroundColor: "rgba(9,166,9,.6)",
                                                borderColor: "rgba(9,166,9,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: companyChildren11
                                            },
                                            {
                                                label: t('Infants'),
                                                backgroundColor: "rgba(78,157,230,.6)",
                                                borderColor: "rgba(78,157,230,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                //hoverBorderColor: 'rgba(255,99,132,1)',
                                                data: companyInfant
                                            },
                                            {
                                                label: t('Pending Pax'),
                                                backgroundColor: "rgba(180,180,180,.6)",
                                                borderColor: "rgba(180,180,180,.6)",
                                                borderWidth: 1,
                                                stack: 1,
                                                data: companyPending
                                            }
                                            ]
                                        }}
                                        options={{
                                            responsive: true,
                                            legend: { display: false },
                                            title: {
                                                display: true,
                                                text: t("Company Report")
                                            },
                                            // scales: {
                                            //     xAxes: [{
                                            //         stacked: true
                                            //     }],
                                            //     yAxes: [{
                                            //         stacked: true
                                            //     }]
                                            // }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h3 className='text-center'>{t('Total Pax (Confirmed)')} : {companyCustomer} / {companyMaxCustomerInMonth} ({companyMaxCustomerInMonth? numberFormatter(2).format(companyCustomer * 100/companyMaxCustomerInMonth): 0}%)</h3>
                            <div className="pie-charts mt-2">
                                <div className="pie-charts-doughnut">
                                    <Doughnut
                                        data={{
                                        labels: companyPieChartLabelsNoPending,
                                        datasets: [
                                            {
                                                label: t("Population (millions)"),
                                                backgroundColor: companyPieColorsNoPending,
                                                data: companyPieChartValuesNoPending
                                            }
                                        ]
                                        }}
                                        option={{
                                            title: {
                                                display: true,
                                                text: t("Total Pax")
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <h3 className='text-center mt-5'>{t('Total Pax (Include Pending)')} : {companyCustomer + companyPendingCustomer} / {companyMaxCustomerInMonth} ({companyMaxCustomerInMonth? numberFormatter(2).format((companyCustomer + companyPendingCustomer) * 100/companyMaxCustomerInMonth): 0}%)</h3>
                            <div className="pie-charts mt-2">
                                <div className="pie-charts-doughnut">
                                    <Doughnut
                                        data={{
                                        labels: companyPieChartLabels,
                                        datasets: [
                                            {
                                                label: t("Population (millions)"),
                                                backgroundColor: companyPieColors,
                                                data: companyPieChartValues
                                            }
                                        ]
                                        }}
                                        option={{
                                            title: {
                                                display: true,
                                                text: t("Total Pax")
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='margin-bottom-50'></hr>
                    <div className='row'>
                        <div className="col-md-6">
                            <h3 className='text-center'>{t('Revenue Chart (VND)')}</h3>
                            <div className="pie-charts mt-2">
                                <div className="pie-charts-doughnut">
                                    <Doughnut
                                        data={{
                                        labels: companyRevenueVNDLabels,
                                        datasets: [
                                            {
                                                label: t("Population (millions)"),
                                                backgroundColor: [
                                                    '#36A2F5', '#34BFA3', '#FF518A', '#E07A10', '#631D7F', '#A426B399', '#F3236699', '#081AF1', '#129A3C', '#102F75', '#e2ec52', '#67655F99'
                                                ],
                                                data: cPieChartRevenuesVND
                                            }
                                        ]
                                        }}
                                        option={{
                                            title: {
                                                display: true,
                                                text: t("Revenue")
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h3 className='text-center'>{t('Revenue Chart (USD)')}</h3>
                            <div className="pie-charts mt-2">
                                <div className="pie-charts-doughnut">
                                    <Doughnut
                                        data={{
                                        labels: companyRevenueUSDLabels,
                                        datasets: [
                                            {
                                                label: t("Population (millions)"),
                                                backgroundColor: [
                                                    '#36A2F5', '#34BFA3', '#FF518A', '#E07A10', '#631D7F', '#A426B399', '#F3236699', '#081AF1', '#129A3C', '#102F75', '#e2ec52', '#67655F99'
                                                ],
                                                data: cPieChartRevenuesUSD
                                            }
                                        ]
                                        }}
                                        option={{
                                            title: {
                                                display: true,
                                                text: t("Revenue")
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ChartBar
